import type { AppRouteModule } from '/@/router/types';

import { LAYOUT } from '/@/router/constant';
import { t } from '/@/hooks/web/useI18n';

const dashboard: AppRouteModule = {
  path: '/implementplan',
  name: 'Implementplan',
  component: LAYOUT,
  redirect: '/implementplan/index',
  meta: {
    hideChildrenInMenu: true,
    icon: 'simple-icons:about-dot-me',
    title: t('routes.dashboard.about'),
    orderNo: 100000,
  },
  children: [
    {
      path: 'index',
      name: 'Implementplan',
      component: () => import('/@/views/implementplan/index.vue'),
      meta: {
        title: t('routes.implementplan'),
        icon: 'simple-icons:about-dot-me',
        hideMenu: true,
      },
    },
    {
      path: 'detailInfo/:id',
      name: 'ImplementplanDetail',
      meta: {
        hideMenu: true,
        title:  t('routes.implementplan'),
      },
      component: () => import('/@/views/implementplan/detailInfo/index.vue'),
    },
    // {
    //     path: 'user',
    //     name: 'todouser',
    //     component: () => import('/@/views/demo/system/todolist/user/index.vue'),
    //     meta: {
    //       title: t('routes.dashboard.about'),
    //       icon: 'simple-icons:about-dot-me',
    //       hideMenu: true,
    //     },
    //   },
  ],
};

export default dashboard;